import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ModelNumStr, NgPrintQrModel, Reparti } from '../../models/-index';

@Injectable()
export class RepartiService extends CrudGenericsService<Reparti, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Reparti`);
    this.base = `${env.apiUrl}/api/Reparti/`;
  }
  Get4Select_ByDiv(div: number = 0): Observable<ModelNumStr[]> {
    const url = this.base + 'Get4Select_ByDiv?div=' + div;
    return this.http.get<ModelNumStr[]>(`${url}`);
  }
  // print etichetta
  GetNgPrintQrModel(id): Observable<NgPrintQrModel> {
    const u = `${this.base}GetNgPrintQrModel?id=${id}`;
    return this.http.get<NgPrintQrModel>(u);
  }
}
